// extracted by mini-css-extract-plugin
export default {"linkBack":"wTC_XNYAiwgL2Bhm_WYmV","linkBackRTL":"I1LEe7s1fs6LnUi1F_mWA","headerTitle":"_3ikgH9gsAYP10m-y6inl-c","grid":"Kh7O9Elcl3ZolNMgHfxXU"};